module.exports = __webpack_public_path__ + "img/Tarjetas.c789b99b.svg";